import React, {PureComponent} from 'react';

import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import style from './IndexFeatured.css';
import Slider from "react-slick";
import {readableDateTime} from "../utils/helpers";


const FeaturedItem = ({record, width, height}) => {
  let {type, object} = record;

  if (type !== 'live') {
    return null;
  }

  return <Link
      to={'/lives/' + object.id}
      className={style.slider}
      style={{
        backgroundImage: `url(${object.image_url})`,
        width: width + 'px',
        height: height + 'px',
      }}>
    {/*<img data-lazy={object.image_url} className={style.slider_img} width={320} height={180}/>*/}
    <span className={style.badge}>{object.threads_count}</span>
    <Link to={'/lives/' + object.id} className={style.slider_title}>
      <time className={style.slider_time}>{readableDateTime(object.news_update_at)}</time>
      <h4>{object.title}</h4>
    </Link>
  </Link>
}

class IndexFeatured extends PureComponent {
  constructor(props) {
    super(props);
    this.sliderRef = React.createRef();
    this.containerRef = React.createRef();
  }

  state = {
    width: 0,
  }

  updateDimensions = () => {
      this.setState({width: this.containerRef.current.offsetWidth});
  }

  componentDidMount() {
      window.addEventListener("resize", this.updateDimensions);
    this.updateDimensions();
  }

  componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
  }

  render() {
    let {featuredRecords} = this.props;
    let {list} = featuredRecords;
    let {width} = this.state;
    let columns = width >= 500 ? 2 : 1;
    let sliderWidth = width / columns - 10;

    const settings = {
      adaptiveHeight: true,
      dots: true,
      slidesToShow: columns,
      slidesToScroll: columns,
      lazyLoad: 'ondemand',
      autoplay: true,
      autoplaySpeed: 10 * 1000,
      // responsive: [
      //   {
      //     breakpoint: 640,
      //     settings: {
      //       slidesToShow: 1,
      //       slidesToScroll: 1
      //     }
      //   },
      //   {
      //     breakpoint: 1024,
      //     settings: {
      //       slidesToShow: 2,
      //       slidesToScroll: 2,
      //     }
      //   }
      // ]
    }


    console.log('width', width, sliderWidth)

    return (
        <section id={'index-featured-slides'} ref={this.containerRef}>
          {width ? (
              <Slider {...settings} ref={this.sliderRef}>
                {/*<div className="btn-toolbar btn-group btn-group-sm">*/}
                {/*  <a href="" className="btn btn-primary">热搜</a>*/}
                {/*  <a href="" className="btn btn-light">热门文章</a>*/}
                {/*  <a href="" className="btn btn-light">单独</a>*/}
                {/*</div>*/}
                {/*<br/>*/}
                {list.slice(0, 10).map((record) => {
                  return <FeaturedItem
                      width={sliderWidth}
                      height={sliderWidth * 0.4}
                      record={record}
                      key={'s' + record.id}
                  />
                })}
              </Slider>

          ) : null}
        </section>
    )
  }
}

export default connect(({featuredRecords}) => ({featuredRecords}))(IndexFeatured);
